module.exports = {
  content: {
    tips: "tips",
    logout: "Are you sure to logout?",
    cancel: "Cancel",
    confirm: "Confirm",
    whetherOrder: "Whether to cancel the order?",
    restored: "Are you sure you want to cancel this order? After canceling the order, it cannot be restored.",
    deleteOrder: "Do you want to delete this order?",
    deleteDestored: "Are you sure you want to delete this order? Once an order is deleted, it cannot be restored.",
    confirmReceipt: "Do you confirm receipt?",
    correctly: "In order to ensure your after-sales rights and interests, please confirm the receipt after receiving the goods and checking them correctly.",
    pleaseProducts: "Please select after-sales products",
    selectAll: "Select All",
    batchManagement: "Batch Management",
    deleteBtn: "Delete",
    saveBtn: "Save",
    check: "Check",
    packUp: "Pack Up",
    answerContinue: "This operation will delete the selected answer, do you want to continue?",
    batchDelete: "Batch Delete",
    operationRecord: "This operation will delete the selected record, do you want to continue?"
  }
}


// WEBPACK FOOTER //
// ./src/assets/lang/en-us/common.js